import { cx } from 'classix';

import Label from './Label';

type Props = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & { label?: string };

export default function TextField({ className, label, ...props }: Props) {
  const input = (
    <input
      type="text"
      className={cx(
        'block w-full rounded-md border-gray-300 bg-white p-3 text-secondary shadow-sm focus:border-amber-500 focus:ring-amber-500',
        className
      )}
      {...props}
    />
  );

  if (!label) {
    return input;
  }

  return <Label label={label}>{input}</Label>;
}
